import { useCallback } from 'react';
import { To, useParams } from 'react-router-dom';

import { localizedResolveTo } from './localizedResolveTo.js';

/**
 * resolveTo with and current location.search by context
 * @note only compatible with react-router-dom v6 and data-router v2
 */
export const useLocalizedResolveTo = () => {
  const { lang: langParam } = useParams();

  return useCallback(
    (to: To, lang?: string | null) => {
      return localizedResolveTo(to, langParam, lang);
    },
    [langParam]
  );
};

export default useLocalizedResolveTo;
